import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavModule } from '../nav-menu/nav.module';
import { FormsModule } from '@angular/forms';
import { CoreModule } from '../core/core.module';
import { UserEditComponent } from './user-edit/user-edit.component';
import { UserComponent } from './user/user.component';
import { UnsubscriberComponent } from './unsubscriber/unsubscriber.component';
import { UnsubscriberEditComponent } from './unsubscriber-edit/unsubscriber-edit.component';



@NgModule({
  declarations: [
    UserComponent,
    UserEditComponent,
    UnsubscriberComponent,
    UnsubscriberEditComponent
  ],
  imports: [
    NavModule,
    CommonModule,
    FormsModule,
    CoreModule
  ]
})
export class AdminModule { }
